import * as actionTypes from "../actions/actionTypes";

export type CookieAuthPilotState = {
  isOptedIn: boolean;
};

const initialState: CookieAuthPilotState = {
  isOptedIn: false,
};

type CookieAuthPilotAction = {
  isOptedIn?: boolean;
  type: string;
};

const reducer = (state = initialState, action: CookieAuthPilotAction): CookieAuthPilotState => {
  switch (action.type) {
    case actionTypes.COOKIE_AUTH_PILOT_OPT_IN_LOADED:
      return { ...state, isOptedIn: Boolean(action.isOptedIn) };

    default:
      return state;
  }
};

export default reducer;
